import React from 'react';
import { Instagram, Phone, Mail, MapPin, Music } from 'lucide-react';
import { gymInfo } from '../data/mockData';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-card border-t border-border-medium">
      <div className="container mx-auto px-5 md:px-10 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <img 
              src={gymInfo.logo} 
              alt={gymInfo.name} 
              className="h-16 w-auto mb-4"
            />
            <p className="body-small text-secondary max-w-md mb-4">
              {gymInfo.tagline}
            </p>
            
            {/* Spotify Link */}
            <a 
              href={gymInfo.spotify}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-wood-lighter hover:text-wood-light transition-all duration-300 group"
            >
              <div className="spotify-footer-icon">
                <Music size={20} />
              </div>
              <span className="body-small font-semibold">האזינו לפלייליסט שלנו</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="heading-5 text-primary mb-4">קישורים מהירים</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="body-small text-secondary hover:text-wood-lighter transition-colors"
                >
                  בית
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="body-small text-secondary hover:text-wood-lighter transition-colors"
                >
                  שירותים
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('trainers')}
                  className="body-small text-secondary hover:text-wood-lighter transition-colors"
                >
                  המאמנים
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('gallery')}
                  className="body-small text-secondary hover:text-wood-lighter transition-colors"
                >
                  גלריה
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="body-small text-secondary hover:text-wood-lighter transition-colors"
                >
                  צור קשר
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="heading-5 text-primary mb-4">צור קשר</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href={`tel:${gymInfo.phone}`}
                  className="body-small text-secondary hover:text-wood-lighter transition-colors flex items-center gap-2"
                >
                  <Phone size={16} />
                  {gymInfo.phone}
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${gymInfo.email}`}
                  className="body-small text-secondary hover:text-wood-lighter transition-colors flex items-center gap-2"
                >
                  <Mail size={16} />
                  {gymInfo.email}
                </a>
              </li>
              <li>
                <p className="body-small text-secondary flex items-start gap-2">
                  <MapPin size={16} className="mt-1 flex-shrink-0" />
                  <span>{gymInfo.address}</span>
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border-medium pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="body-small text-secondary text-center md:text-right">
            © {new Date().getFullYear()} House Of Fitness. כל הזכויות שמורות.
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a 
              href={gymInfo.spotify}
              target="_blank"
              rel="noopener noreferrer"
              className="text-secondary hover:text-wood-lighter transition-colors spotify-icon"
              aria-label="Spotify"
            >
              <Music size={20} />
            </a>
            <a 
              href={gymInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="text-secondary hover:text-wood-lighter transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
